import React from "react";

const Controls = ({
  onDrive,
  onDriveFast,
  onBrake,
  onBuyFuel,
  onBuyStock,
  onSellStock,
  canBuyFuel,
  canBuyStock,
  canSellStock
}) => (
  <div style={{ margin: 16 }}>
    <button onMouseDown={onDrive} style={{ marginRight: 8 }}>
      Drive (Hold)
    </button>
    <button onMouseDown={onDriveFast} style={{ marginRight: 8 }}>
      Drive Fast (Double Click/Hold)
    </button>
    <button onMouseDown={onBrake} style={{ marginRight: 8 }}>
      Brake (Hold)
    </button>
    <button onClick={onBuyFuel} disabled={!canBuyFuel} style={{ marginRight: 8 }}>
      Buy Fuel
    </button>
    <button onClick={onBuyStock} disabled={!canBuyStock} style={{ marginRight: 8 }}>
      Buy Stock
    </button>
    <button onClick={onSellStock} disabled={!canSellStock}>
      Sell Stock
    </button>
  </div>
);

export default Controls;